// extracted by mini-css-extract-plugin
export default {"add-item-form":"ClipForm_add-item-form__uNb6K","addItemForm":"ClipForm_add-item-form__uNb6K","help-text":"ClipForm_help-text__o-kKX","helpText":"ClipForm_help-text__o-kKX"};